import React, { useEffect, useState } from "react";
import TimeIcon from "../../Assets/TimeIcon.svg";
import { getAppAnalytics } from "./analytics.service";

const AverageSessionApp = ({ app }) => {
    const [result, setResult] = useState(['00', '00', '00']);
    const [duration, setDuration] = useState();
    useEffect(async () => {
        const res = await getAppAnalytics('averageSessionApp', app?.packageName, app?.platform,app?.title);
        const date = new Date(null);
        if(res.data.data.TotalNoOfSession===0){
            setDuration(0)
        }
        else{
            date.setSeconds(res.data.data.TotalDuration / res.data.data.TotalNoOfSession);
            setResult(date.toISOString().substr(11, 8).split(":"));
        }
    }, []);
    return (
        <div className="card p_all-20 flex-point-5" >
            <div className="z-index-2">
                <div className="font-bold font-size-14">
                    Average Session Time
                </div>
                {duration !== 0 ? (
                    <div className="d-flex">
                    {result[0] != '00' && <div className="d-flex pr-10">
                        <h1>{result[0]}</h1><span className="mtc-15 mlc-3 font-size-20">h</span>
                    </div>}
                    {(result[0] != '00' || result[1] != '00') && <div className="d-flex pr-10">
                        <h1>{result[1]}</h1><span className="mtc-15 mlc-3 font-size-20">m</span>
                    </div>}
                    {<div className="d-flex pr-10">
                        <h1>{result[2]}</h1><span className="mtc-15 mlc-3 font-size-20">s</span>
                    </div>}
                </div>):(<span className="text-gray font-size-32 font-bold">NA</span>)}
            </div>
            <div className="z-index-1">
                <img
                    className="icon pr-50 pb-25"
                    src={TimeIcon}
                    alt=""
                />
            </div>
        </div>
    )
}

export default AverageSessionApp;